<template>
  <v-select
    dense
    v-model="siteTemp"
    :items="listeSites"
    item-text="LIC_URL"
    item-value="LIC_ID"
    :label="$t('select') + ' ' + $tc('sites', 1, {count: ''}) | cap"
    return-object
    @input="updateSite()"
    prepend-icon="language"
    :persistent-hint="hint.trim().length > 0"
    :hint="hint"
    :disabled="disabled || !listeSites.length"
  ></v-select>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    hint: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      siteTemp: null,
      listeSites: []
    }
  },
  created () {
    this.refreshSiteList()
    if (this.siteTemp) {
      this.$emit('update:site', this.siteTemp)
    }
  },
  methods: {
    isBotActivated (site) {
      if (!site) return false
      const value = site.LIC_BOT_ACTIVATED
      return value === '1' || value === 1 || value === true || value === 'true'
    },
    refreshSiteList () {
      const allSites = _.cloneDeep(this.$store.state._Sites.sites || [])
      this.listeSites = allSites.filter(site => this.isBotActivated(site))

      const currentId = this.$store.state._Sites.siteSelected && this.$store.state._Sites.siteSelected.LIC_ID
      this.siteTemp = _.find(this.listeSites, { LIC_ID: currentId }) || this.listeSites[0] || null

      if (this.siteTemp) {
        this.$store.commit('_Sites/UPDATE_SITE_SELECTED', this.siteTemp)
      }
    },
    updateSite () {
      this.$emit('update:site', this.siteTemp)
      if (this.siteTemp) {
        this.$store.commit('_Sites/UPDATE_SITE_SELECTED', this.siteTemp)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSelectOneSiteBot.vue